<template>
  <div class="main-container">
    <!-- 页面标题 -->
    <h1 class="page-title">考研服务与问答中心</h1>

    <!-- 标签筛选 -->
    <div class="tag-bar">
      <span class="tag-label">类型：</span>
      <span
        class="tag-item"
        :class="{ active: currentTagId === 0 }"
        @click="onTagChange(0)"
      >不限</span>
      <span
        v-for="tag in tags"
        :key="tag.id"
        class="tag-item"
        :class="{ active: currentTagId === tag.id }"
        @click="onTagChange(tag.id)"
      >{{ tag.name }}</span>
      <span
        class="tag-item"
        :class="{ active: currentTagId === 100 }"
        @click="onTagChange(100)"
      >学员服务说明</span>
    </div>

    <!-- 普通列表 -->
    <div v-if="currentTagId !== 100" class="list-wrap" v-loading="listLoading">
      <div v-if="newsList.length > 0" class="list-content">
        <div
          v-for="item in newsList"
          :key="item.id"
          class="list-item"
          @click="goDetail(item)"
        >
          <div class="item-info">
            <div class="item-title">
              <span v-if="item.is_top == 1" class="top-tag">置顶</span>
              {{ item.name }}
            </div>
            <div class="item-subtitle">{{ item.subtitle }}</div>
          </div>
          <div class="item-date">{{ formatTime(item.createTime) }}</div>
        </div>
      </div>
      <Empty v-else-if="!listLoading" class="empty" title="暂无资讯信息哦！" />
      <el-pagination
        v-if="total > pageSize"
        class="pager"
        background
        layout="total, prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page.sync="pageNo"
        @current-change="onPageChange"
      ></el-pagination>
    </div>

    <!-- 学员服务说明卡片区 -->
    <div v-else class="service-cards">
      <div
        v-for="item in serviceTopics"
        :key="item.id"
        class="service-card"
        @click="goService(item.id)"
      >
        <div class="service-card-img">
          <img :src="item.imgUrl" :alt="item.name" />
        </div>
        <span class="service-card-name">{{ item.name }}</span>
        <span class="service-card-desc">{{ item.subtitle }}</span>
        <span class="service-card-link">点击查看详情</span>
      </div>
    </div>
  </div>
</template>

<script>
const TAG_API = "https://www.mempku.com/app-api/qbby/notice/tags";
const LIST_API = "https://old.qbbystudy.com/api/old_qbby/notice/list";

export default {
  name: "News",
  data() {
    return {
      tags: [],
      currentTagId: 0,
      tagLoading: false,
      newsList: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      listLoading: false,
      scrollTop: 0,

      serviceTopics: [
        {
          id: "serviceDescription",
          name: "课程开通与学习服务",
          subtitle: "了解报名后课程开通、资料获取和学习服务安排。",
          imgUrl: require("../../images/notice/service-course.png"),
        },
        {
          id: "feedbackInstructions",
          name: "学习服务反馈与处理",
          subtitle: "学习过程中遇到问题、可查看反馈渠道和处理方式。",
          imgUrl: require("../../images/notice/service-feedback.png"),
        },
        {
          id: "rightsProtection",
          name: "学习保障与重修",
          subtitle: "符合相关条件的学习保障、重修安排可在此查看。",
          imgUrl: require("../../images/notice/service-retake.png"),
        },
        {
          id: "refundPolicy",
          name: "课程退费办理",
          subtitle: "了解退费申请方式、办理流程及相关规则说明。",
          imgUrl: require("../../images/notice/service-refund.png"),
        },
      ],
    };
  },
  async created() {
    await this.fetchTags();
    await this.fetchNewsList();
  },
  activated() {
    window.scrollTo(0, this.scrollTop);
  },
  beforeRouteLeave(_to, _from, next) {
    this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    next();
  },
  methods: {
    async fetchTags() {
      this.tagLoading = true;
      try {
        const res = await this.$http.get(TAG_API, {}, { showLoading: false, skipApiError: true });
        const list = Array.isArray(res) ? res : (res.data || []);
        this.tags = list;
      } catch (e) {
        console.error("获取标签失败:", e);
        this.tags = [];
      } finally {
        this.tagLoading = false;
      }
    },

    async fetchNewsList() {
      this.listLoading = true;
      try {
        const params = { pageNo: this.pageNo, pageSize: this.pageSize };
        if (this.currentTagId && this.currentTagId !== 0) {
          params.tagIds = this.currentTagId;
        }
        const res = await this.$http.get(LIST_API, params, { showLoading: false, skipApiError: true });
        const payload = res.data || res;
        this.newsList = payload.list || [];
        this.total = payload.total || 0;
      } catch (e) {
        console.error("获取资讯列表失败:", e);
        this.newsList = [];
        this.total = 0;
      } finally {
        this.listLoading = false;
      }
    },

    onTagChange(tagId) {
      if (this.currentTagId === tagId) return;
      this.currentTagId = tagId;
      if (tagId === 100) return; // 服务卡片，不请求列表
      this.pageNo = 1;
      this.fetchNewsList();
    },

    onPageChange(page) {
      this.pageNo = page;
      this.fetchNewsList();
      document.body.scrollIntoView(true);
    },

    goDetail(item) {
      this.$router.push({ name: "NewsShow", params: { id: item.id } });
    },

    goService(id) {
      this.$router.push({ name: "NewsShow", params: { id } });
    },

    formatTime(ts) {
      if (!ts) return "";
      const d = new Date(ts);
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${y}-${m}-${day}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-title {
  font-size: 24px;
  font-weight: bold;
  color: #121212;
  margin: 34px 0 17px;
}

.tag-bar {
  margin-bottom: 30px;
}
.tag-label {
  font-size: 15px;
  font-weight: 400;
  color: #666;
}
.tag-item {
  display: inline-block;
  padding: 2px 5px;
  font-size: 15px;
  font-weight: 400;
  color: #121212;
  margin-right: 20px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  user-select: none;
  &:hover { color: #dc2c32; }
  &.active { background: #dc2c32; color: #fff; }
}

.list-wrap {
  min-height: 400px;
  padding-bottom: 50px;

  /deep/ .el-loading-mask {
    background-color: transparent;
  }
}
.list-content { max-width: 1180px; }
.list-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 4px 0;
  margin-bottom: 20px;
  cursor: pointer;
  width: 80%;
  &:hover .item-title { color: #dc2c32; }
}
.item-info { flex: 1; }
.item-title {
  font-size: 18px;
  font-weight: 400;
  color: #121212;
  margin-bottom: 4px;
  transition: color 0.2s;
}
.top-tag {
  display: inline-block;
  padding: 1px 6px;
  margin-right: 6px;
  font-size: 12px;
  font-weight: 500;
  color: #dc2c32;
  border: 1px solid #dc2c32;
  border-radius: 3px;
  vertical-align: middle;
}
.item-subtitle { font-size: 14px; font-weight: 400; color: #999; }
.item-date {
  font-size: 18px;
  font-weight: 400;
  color: #121212;
  flex-shrink: 0;
  margin-left: 20px;
}
.empty { padding: 80px 0; }

// 分页
.pager {
  margin-top: 36px;
  text-align: center;
  /deep/ {
    button {
      min-width: 32px; padding: 0 6px;
      color: #999 !important; background: transparent !important;
      &[disabled] { opacity: 0.5; }
    }
    .el-pagination__total { height: 32px; line-height: 32px; margin-right: 16px; }
    .btn-prev { margin: 0 8px 0 0 !important; }
    .btn-next { margin: 0 0 0 8px !important; }
    .el-pager li {
      margin: 0 8px 0 0 !important;
      color: #666; background: transparent !important;
      min-width: 32px; height: 32px; line-height: 32px; border-radius: 4px;
      &:last-child { margin-right: 0 !important; }
      &.number.active { border: 1px solid #dc2c32 !important; color: #fff; }
    }
  }
}

// 学员服务卡片
.service-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-top: 20px;
  padding-bottom: 50px;
}
.service-card {
  display: block;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, .06);
  transition: box-shadow .3s;
  text-decoration: none;
  text-align: center;
  cursor: pointer;
  &:hover { box-shadow: 0 4px 20px rgba(0, 0, 0, .12); }
}
.service-card-img {
  width: 100%;
  height: 160px;
  overflow: hidden;
  background: #fff;
  img { width: 100%; height: 100%; object-fit: contain; }
}
.service-card-link {
  display: inline-block;
  margin: 10px auto 20px;
  padding: 6px 20px;
  font-size: 14px;
  color: #dc2c32;
  border: 1px solid #dc2c32;
  border-radius: 18px;
  text-align: center;
  background: transparent;
}
.service-card-name {
  display: block;
  padding: 0 15px;
  margin: 10px;
  font-size: 17px;
  font-weight: 500;
  color: #121212;
  text-align: center;
}
.service-card-desc {
  display: block;
  padding: 0 15px;
  margin: 10px;
  font-size: 12px;
  font-weight: 500;
  color: #666;
  text-align: center;
}

@media screen and (max-width: 1440px) {
  .list-item { width: 100%; }
  .service-cards { grid-template-columns: repeat(2, 1fr); }
}
</style>
